import { render, staticRenderFns } from "./OpenLoads.vue?vue&type=template&id=407a9808&"
import script from "./OpenLoads.vue?vue&type=script&lang=js&"
export * from "./OpenLoads.vue?vue&type=script&lang=js&"
import style0 from "./OpenLoads.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports